import React, { useState } from 'react';
import ContactDetailsForm from '../contact-details-form/contact-details-form';
import AddressForm from '../address-form/address-form';
import './contact-details-handler.scss';
import { FMButton } from '@own/fds-react';
import { useOSBContentFragment } from '../../../../../hooks/owners-osb/aem-content-util/use-osb-content-fragment';
import PrivacyText from '../../common/privacy-text/privacy-text';

const ContactDetailsHandler = () => {
    const contactDetailsContent =
        useOSBContentFragment('common/osb-v3', 'contact-details-step') || {};
    const addressContent =
        useOSBContentFragment('common/osb-v3', 'pickup-and-delivery-address') ||
        {};
    const isLoadingContinue = !contactDetailsContent?.continueButtonLabel;
    const isLoadingPrivacy = !addressContent?.privacyText;
    const urlParams = new URLSearchParams(window.location.search);
    const isPnd = urlParams.get('pnd');
    const isMsv = urlParams.get('msv');
    const fromSession = sessionStorage.getItem('showAddressForm') === 'true';
    const shouldShowAddressForm =
        isPnd === 'true' || isMsv === 'true' || fromSession;
    const [isContactFormValid, setIsContactFormValid] = useState(false);
    const [isAddressFormValid, setIsAddressFormValid] = useState(false);

    const handleAddressFormValidityChange = (isValid: boolean) => {
        setIsAddressFormValid(isValid);
    };
    const handleContactFormValidityChange = (isValid: boolean) => {
        setIsContactFormValid(isValid);
    };

    const handleContinue = () => {
        console.log('Continue clicked');
    };
    const isContinueDisabled =
        !isContactFormValid || (shouldShowAddressForm && !isAddressFormValid);
    const PrivacyFooterComponent = (
        <div className="osb-v3-privacy-footer">
            {isLoadingPrivacy ? (
                <div
                    className="osb-v3-privacy-skeleton"
                    data-testid="privacy-skeleton"
                ></div>
            ) : (
                <PrivacyText
                    fullPrivacyText={addressContent.privacyText as string}
                    linkText={addressContent.privacyLinkText as string}
                    privacyUrl={addressContent.privacyLinkUrl as string}
                />
            )}
        </div>
    );
    return (
        <div
            className="osb-v3-contact-details-handler"
            data-testid="contact-details-handler"
        >
            <div className="osb-v3-contact-form-wrapper">
                <ContactDetailsForm
                    data-testid="contact-form"
                    onValidityChange={handleContactFormValidityChange}
                />
                {!shouldShowAddressForm && PrivacyFooterComponent}
            </div>
            {shouldShowAddressForm && (
                <div className="osb-v3-address-form-wrapper">
                    <AddressForm
                        data-testid="address-form"
                        onValidityChange={handleAddressFormValidityChange}
                    />
                    {PrivacyFooterComponent}
                </div>
            )}
            <div className="osb-v3-button-container">
                {isLoadingContinue ? (
                    <div
                        className="osb-v3-continue-skeleton-button"
                        data-testid="skeleton-button"
                    ></div>
                ) : (
                    <FMButton
                        ariaLabel="continue-button"
                        data-testid="continue-button"
                        label={contactDetailsContent.continueButtonLabel}
                        theme="light"
                        type="primary"
                        onClick={handleContinue}
                        disabled={isContinueDisabled}
                    />
                )}
            </div>
        </div>
    );
};

export default ContactDetailsHandler;
